import React, { useCallback } from 'react';
import { Button, Row, Col } from 'reactstrap';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
  Intl, LocalTable, ModalForm,
} from 'components';
import { handlePromise } from 'utils';
import ListPhoneNumbersService from 'api/ListPhoneNumbers';
import SettingsActions from 'store/reducers/Settings';

const GenericContactModal = ( {
  contacts, modalTitle, tableTitle, open, onClose, toggleLoading, type = 'duplicate',
} ) => {
  const exportPhones = useCallback( async () => {
    toggleLoading( true );
    const [errors, response, responseData] = await handlePromise(
      ListPhoneNumbersService.exportListPhoneNumbers( {
        type,
        phoneNumbers: _.map( contacts, ( contact ) => ( {
          nameId: contact.nameId,
          phoneNumber: contact.phoneNumber,
        } ) ),
      } ),
    );
    toggleLoading( false );
    if ( !response.ok ) return _.isString( errors ) ? 'errors' : 'apiError';
    window.open( responseData.uri );
  }, [contacts, type, toggleLoading] );

  return (
    <ModalForm
      title={modalTitle}
      size="lg"
      showErrorsInHeader
      open={open}
      onClose={onClose}
      onSubmit={exportPhones}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          onClick={onClose}
        >
          <Intl id="okBtn" />
        </Button>
      )}
    >
      <Row className="my-3">
        <Col md="auto" className="m-auto">
          <div className="campaign-wizard-table">
            <LocalTable
              data={contacts.length < 5
                ? contacts.concat( new Array( 5 - contacts.length ).fill( { empty: true } ) )
                : contacts}
              manualPagination
              onlyTable
              columns={[
                {
                  Header: 'nameOrId',
                  accessor: 'nameId',
                  customWidth: 140,
                },
                {
                  Header: <Intl
                    id={tableTitle}
                    values={{ total: contacts.length }}
                  />,
                  disableSorting: true,
                  disableTranslate: true,
                  accessor: 'phoneNumber',
                  customWidth: 260,
                },
              ]}
            />
          </div>

          <Button
            color="app-default"
            size="app-sm"
            block
            className="font-weight-700 mt-3"
          >
            <Intl id="download" />
          </Button>
        </Col>
      </Row>
    </ModalForm>
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( GenericContactModal );
